export default __webpack_public_path__ + "static/media/home-promo.40b39f8c.png";